import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import "react-datepicker/dist/react-datepicker.css";
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import { getAdvBudgetPerformanceData, handleLoader } from '../../../../redux/actions/AdvBudgetPerformanceActions';
import { tableAdvBudgetPerformance } from '../../helper';
import ViewReportModel from './ViewReportModel';
import AdvBudgetCompaignWise from './AdvBudgetCompaignWise';

const AdvBudgetPerformance = ({ dispatch, rtl }) => {
    const { t } = useTranslation('common');
    const location = useLocation();

    const { isLoading, advBudgetPerformanceData, salesChannelFilterData } = useSelector(
        ({ advBudgetPerformanceReducer, marketPlaceReducer }) =>
        ({
            salesChannelFilterData: marketPlaceReducer.salesChannel,
            advBudgetPerformanceData: advBudgetPerformanceReducer.advBudgetPerformanceData,
            isLoading: advBudgetPerformanceReducer.isLoading,
        })
    );

    const filtersObj = advBudgetPerformanceData?.modal?.filters?.[0];
    const [isOpen, setIsOpen] = useState(false);
    const [advBudgetPerformanceDataToShow, setAdvBudgetPerformanceDataToShow] = useState([]);
    const [selectedCampaignOptions, setselectedCampaignOptions] = useState();
    const [filterData, setFilterData] = useState({});
    const [dateRange, setDateRange] = useState([new Date(moment().subtract(1, 'month')), new Date(moment())]);
    const [startDate, endDate] = dateRange;

    const campaignTypeOptions = [];
    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }
        return flag
    }

    // eslint-disable-next-line array-callback-return
    advBudgetPerformanceData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data) => {
    data.filterData.forEach((element) => {
      campaignTypeOptions.push({
        value: element.key,
        label: element.shortValue
      });
    });
  });

  const sortedCampaignTypeOptions = campaignTypeOptions.sort((a, b) => a.label > b.label ? 1 : -1)

  // eslint-disable-next-line react/prop-types
  const changeFilterForCampaignType = (value) => {
    setselectedCampaignOptions(value)
  };

    const callApi = () => {
        dispatch(handleLoader(true))
        dispatch(getAdvBudgetPerformanceData({
            fromDate: moment(startDate).format('YYYY-MM-DD'),
            toDate: moment(endDate).format('YYYY-MM-DD')
        }));
    }

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvChartF = document.getElementById('dvChartFilter');
    const dvChartV = document.getElementById('dvChartView');
    dvChartF.style.display = "none";  
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Adv Budget Performance Report ${new Date().getFullYear()}`,
    })
    dvChartF.style.display = "block";  
    dvChartV.style.display = "block"; 
  }

    const handleApplyDate = () => {
        callApi()
    }

    const viewReportButton = () => (
        <div className="view-report" style={{ zIndex: 2, top: '-25px', right: '-45px' }}>
            <button
                type="button"
                className="view-report btn btn-primary btn-sm"
                onClick={() => setIsOpen(true)}
            >
                View Report
            </button>
        </div>
    )

    useEffect(() => {
        dispatch(handleLoader(true));
        callApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setAdvBudgetPerformanceDataToShow(advBudgetPerformanceData?.modal?.data || []);
    }, [advBudgetPerformanceData]);
    console.log(filterData)
console.log(advBudgetPerformanceData?.modal?.data)
    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData]);

    let advBudgetPerformanceDataToShowForDatesSelected = advBudgetPerformanceDataToShow?.filter(item =>
        filterBasedOnFilter(item));

    if (selectedCampaignOptions?.length) {
            const selected = selectedCampaignOptions?.reduce((acc, item) => {
              acc[item?.value] = item.value
              return acc
            }, {})
            advBudgetPerformanceDataToShowForDatesSelected = advBudgetPerformanceDataToShowForDatesSelected.
            filter(item => selected[item.campaignType])
    }

    return (
        <Container className="dashboard">
            <Row className="monthly-subscription-order">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">Adv Budget Performance </h5>
                            </div>
                            <Row className="align-items-center">
                                {/* <Col md="2">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Country</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={filterData?.countryCode || []}
                                                options={filtersObj?.filterData?.map(countr =>
                                                    ({ label: countr.longValue, value: countr.key }))}
                                                clearable={false}
                                                placeholder="Select Country"
                                                className="select_filter"
                                                onChange={value => setFilterData({
                                                    ...filterData,
                                                    countryCode: value
                                                })}
                                                classNamePrefix="react-select"
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                </Col> */}
                                <Col md="8">
                                    <Row className="align-items-center">
                                        <Col sm="4">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">

                                                        <DatePicker
                                                            dateFormat="MM/dd/yyyy"
                                                            selectsRange
                                                            startDate={startDate}
                                                            endDate={endDate}
                                                            onChange={(update) => {
                                                                setDateRange(update);
                                                            }}
                                                            withPortal={isMobileOnly}

                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </Col>
                                        <Col sm="8" style={{ top: '10px' }}>
                                            <button className="btn btn-sm btn-primary apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button>
                                                <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                        </Col>
                                    </Row>
                                </Col>                                
                      <Col sm="3" className='align-items-center'>
                      <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Filter Type</span>
                    <div className="form__form-group-field">
                      <Select
                        value={selectedCampaignOptions}
                        options={sortedCampaignTypeOptions}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter-300"
                        onChange={changeFilterForCampaignType}
                        classNamePrefix="react-select"
                        isMulti
                      />
                    </div>

                  </div>
                      </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div id="divToPrint" ref={container}>
            <Card className="pb-3">
                <CardBody className="">
                    <Row className="show-sales-region">
                        <Col md="12">
                            <Card>
                                <CardBody className="p-0">
                                    <div className="top-location" style={{ minHeight: '400' }}>
                                        <div >
                                            {isLoading ? <div style={{ minHeight: '200px' }}
                                                className="row align-items-center justify-content-center">
                                                <SmallLoader loading={isLoading} />
                                            </div>
                                                : <AdvBudgetCompaignWise
                                                    title="Adv Budget Performance By Campaign"
                                                    viewReportButton={viewReportButton}
                                                    data={advBudgetPerformanceDataToShowForDatesSelected}
                                                    dir={rtl.direction}
                                                />}
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            </div>
            <ViewReportModel
                data={advBudgetPerformanceDataToShowForDatesSelected}
                isOpen={isOpen}
                handleModal={setIsOpen}
                title="Adv Budget Performance"
                fileName="Adv Budget Performance "
                tableHeaderData={tableAdvBudgetPerformance} />

        </Container>
    );
};

AdvBudgetPerformance.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
};

export default connect(state => ({
    rtl: state.rtl,
}))(AdvBudgetPerformance);
